import React from 'react';
import { useNotification } from '../context/NotificationContext';
import './Notification.css';

const Notification: React.FC = () => {
  const { notifications, dismissNotification } = useNotification();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-container" aria-live="polite">
      {notifications.map((item) => (
        <div
          key={item.id}
          className={`notification notification--${item.type}`}
          role="alert"
        >
          <span className="notification-icon">
            {item.type === 'success' ? '✓' : '!'}
          </span>
          <p className="notification-message">{item.message}</p>
          <button
            type="button"
            className="notification-close"
            onClick={() => dismissNotification(item.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default Notification;
